import type { ReactNode } from 'react';

/**
 * 右栏：**运营秘书 + 运行日志**（原型 v0.22 第 1032–1052 行）。
 *
 * ## 从 SBX 演示值改为**零态**（C-160 口径一）
 *
 * 两块的源都是 `taskrun`——**表在库里（20 列），这个实例零行**。
 * 按口径一，那是**零态**，不是无源；而零态**不得用演示值顶替**：
 *
 * > 零态与无源在类型层互斥（ADR-0047），不得互相顶替；
 * > 无源格一律不填演示文本、不填演示数字。
 *
 * 此前这里逐字搬了原型的四条待办与六条日志（「冶炼工艺卡 tr-H1…9B」那些）。
 * 那些是**演示文本**，而这一块的源是有的——**只是还没有数据**。
 * 于是照零态呈现：说清「今天没有」，并说清它一有记录就会自己出现。
 *
 * C-160 五 已把热力图的运行态改成零态，两处同源，这里一并对齐——
 * 上一轮我提请裁定「右栏与热力图口径不一致」，口径一 已经答了：**都是零态。**
 *
 * ## 「今日」要走 `app.biz_date()`（I-7）
 *
 * 不是 `current_date`、也不是应用侧的 `new Date()`。它是「哪一天的账」，由锚点决定。
 * 接数据那一步在这里读 `taskrun`，日界必须由 `app.biz_date(tenant_id)` 给。
 */
export function RightRail(): ReactNode {
  return (
    <div>
      <div className="card sec">
        <h3>
          运营秘书 <span className="sub">今日待办</span>
        </h3>
        <div className="note">
          今天没有待办。这一栏装三类：待审批、连续异常、待确认的回溯注入建议。
          第一次执行发生的当天，这里就会有内容。
        </div>
      </div>

      <div className="card log">
        <h3>
          运行日志 <span className="sub">今日 TaskRun 事件</span>{' '}
        </h3>
        <div className="note">
          今天没有 TaskRun 事件。「今日」按业务日算，锚点是
          Organization.timezone——不是服务器的当天。
        </div>
      </div>
    </div>
  );
}
